'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servicesAPI = exports.isStaging = exports.isJustGiving = exports.getPlatform = exports.getBaseURL = exports.updateClient = exports.destroy = exports.put = exports.post = exports.get = exports.instance = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _params = require('../params');

var _map = require('../map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
  baseURL: process.env.SUPPORTICON_BASE_URL || 'https://everydayhero.com'
};

var instance = exports.instance = _axios2.default.create(defaults);

var get = exports.get = function get() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var params = arguments[1];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return instance.get(endpoint, _extends({ params: (0, _map2.default)(params, options) }, config)).then(function (response) {
    return response.data;
  }).catch(function (error) {
    return Promise.reject(error.response);
  });
};

var post = exports.post = function post() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var data = arguments[1];
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return instance.post(endpoint, data, config).then(function (response) {
    return response.data;
  }).catch(function (error) {
    return Promise.reject(error.response);
  });
};

var put = exports.put = function put() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var data = arguments[1];
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return instance.put(endpoint, data, config).then(function (response) {
    return response.data;
  }).catch(function (error) {
    return Promise.reject(error.response);
  });
};

var destroy = exports.destroy = function destroy() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return instance.delete(endpoint, config).then(function (response) {
    return response.data;
  }).catch(function (error) {
    return Promise.reject(error.response);
  });
};

var updateClient = exports.updateClient = function updateClient() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  Object.keys(options).map(function (option) {
    instance.defaults[option] = options[option];
  });

  updateServicesAPIClient();
};

var getBaseURL = exports.getBaseURL = function getBaseURL() {
  return instance.defaults.baseURL;
};

var getPlatform = exports.getPlatform = function getPlatform() {
  return (/justgiving/.test(instance.defaults.baseURL) ? 'justgiving' : 'everydayhero'
  );
};

var isJustGiving = exports.isJustGiving = function isJustGiving() {
  return (/justgiving/.test(instance.defaults.baseURL)
  );
};
var isStaging = exports.isStaging = function isStaging() {
  return (/staging/.test(instance.defaults.baseURL)
  );
};

// Services API Client
var servicesAPI = exports.servicesAPI = _axios2.default.create({
  baseURL: 'https://api.blackbaud.services'
});

var updateServicesAPIClient = function updateServicesAPIClient() {
  servicesAPI.defaults.baseURL = isStaging() ? 'https://api-staging.blackbaud.services' : 'https://api.blackbaud.services';
};

exports.default = {
  instance: instance,
  get: get,
  post: post,
  put: put,
  destroy: destroy,
  updateClient: updateClient,
  getBaseURL: getBaseURL,
  getPlatform: getPlatform,
  isJustGiving: isJustGiving,
  isStaging: isStaging,
  servicesAPI: servicesAPI
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/utils/client/index.js
// module id = 4
// module chunks = 0